/*
  MIT License

  Copyright (c) 2018 Riad Loukili <rizoox@icloud.com>

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

import { h, Component } from 'preact'
import Router, { route } from 'preact-router'
// Routes
import Loading from './routes/Loading'
import Network from './routes/Network'
import Lookup from './routes/Lookup'
import Saved from './routes/Saved'
import Generator from './routes/Generator'
// Components
import Redirect from './components/Redirect'
import Wireframe from './components/Wireframe'

export default class App extends Component {

  state = {
    tabsVisible: false
  }

  handleRoute(e) {
    if(e.url === "/" || e.url === "/loading") {
      if(e.url === "/loading") (window && window.gtag && window.gtag('config', 'UA-127784225-1', {'page_path': '/loading'}));
      this.setState({tabsVisible: false})
    } else {
      this.setState({tabsVisible: true})
    }
    let currentPage = 0;
    switch (e.url) {
      case '/lookup':
        (window && window.gtag && window.gtag('config', 'UA-127784225-1', {'page_path': '/lookup'}));
        currentPage = 1
        break
      case '/saved':
        (window && window.gtag && window.gtag('config', 'UA-127784225-1', {'page_path': '/saved'}));
        currentPage = 2
        break
      case '/network':
        (window && window.gtag && window.gtag('config', 'UA-127784225-1', {'page_path': '/network'}));
        currentPage = 3
        break
      case '/generator':
        (window && window.gtag && window.gtag('config', 'UA-127784225-1', {'page_path': '/generator'}));
      default:
        currentPage = 0
        break
    }
    this.setState({ currentPage })
  }

  onTabsChange(i) {
    switch (i) {
      case 1:
        route('/lookup')
        break
      case 2:
        route('/saved')
        break
      case 3:
        route('/network')
        break
      case 0:
      default:
        route('/generator')
        break
    }
  }

  render() {
    return (
      <div style={{minHeight: '100vh'}}>
        <Wireframe tabsVisible={this.state.tabsVisible} onTabsChange={this.onTabsChange.bind(this)} currentPage={this.state.currentPage}>
          
          <Router onChange={this.handleRoute.bind(this)}>
            <Redirect path="/" to="/loading" />
            <Loading path="/loading" />
            <Network path="/network" />
            <Lookup path="/lookup" />
            <Saved path="/saved" />
            <Generator path="/generator" />
          </Router>

        </Wireframe>
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./App.js